import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../atoms/modal/Modal';

import LinkButton from '../atoms/button/LinkButton';

const Caution = ({ message, className }) => {
  const [showModal, setShowModal] = useState(false);

  if (!message) {
    return null;
  }

  const title = '施設に関するご案内・ご注意';

  const onClose = () => setShowModal(false);

  return (
    <React.Fragment>
      <div className={`cautionWrapper ${className}`}>
        <div className="caution clickable" onClick={() => setShowModal(true)}>
          <span className="cautionMessage">{title}</span>
          <img
            className="cautionIcon"
            src="/dpp/img/icons/question.png"
          />
        </div>
      </div>
      <Modal
        open={showModal}
        onClose={onClose}
        className="cautionModal"
        bodyClassName="cautionModalBody"
        overlayClassName="cautionModalOverlay"
        customHeader={() => (
          <div className="cautionModalHeader">
            <div className="cautionModalHeaderTitle">{title}</div>
            <div className="cautionModalClose" onClick={onClose}/>
          </div>
        )}
      >
        <div>
          <div className="cautionModalMessage" dangerouslySetInnerHTML={{ __html: message }}/>
          <div className="cautionModalActions">
            <LinkButton className="cautionModalButton" buttonType="navigate" onClick={onClose}>閉じる</LinkButton>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

Caution.defaultProps = {
  className: '',
};

Caution.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
};

export default Caution;
